<template>
  <div class="row">
    <div class="col-6" :class="leftClass">
        <h1 class="text-uppercase"  v-bind:class="{ 'mt-5': !authenticated, 'mb-5': authenticated }" v-if="title" v-html="title"></h1>
    </div>

    <div class="col-6 text-right mt-4" :class="rightClass">
      <span class="title-icons" v-if="showIcons">
        <a v-if="authenticated" href="#" class="text-primary-3"><i class="fa fa-search"></i></a>
        <a v-if="authenticated" href="#" class="text-primary-2"><i class="far fa-calendar-alt"></i></a>
        <a href="#" class="text-primary-2" v-if="event" v-on:click.prevent="$parent.popups.shareModel = true"><i class="fa fa-share-alt"></i></a>
        <a v-if="authenticated" href="#" class="text-primary"><i class="far fa-bell"></i> <span class="counter">20</span></a>
      </span>
      <router-link class="login-brand" to="/">
          <img :src="$APP_CONFIG.APP_LOGO" class="logo mb-1" :style="`max-width: ${logoWidth}px;`" />
      </router-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'page-title',
    props: {
      title: {
        type: String,
        default: ''
      },
      leftClass: {
        type: String,
        default: ''
      },
      rightClass: {
        type: String,
        default: ''
      },
      showIcons: {
        type: Boolean,
        default: false
      },
      logoWidth: {
        type: Number,
        default: 54
      },
      event: {
        type: Object
      },
      authenticated: {
        type: Boolean,
        default: true
      },
      appLink: {
        type: String
      }
    }
  };
</script>
<style></style>
